export const statusChoicesDict = {
  Available: { id: 1, name: "Available", color: "success" },
  Out_of_service: { id: 2, name: "Out of service", color: "warning" },
  Pending: { id: 3, name: "Pending", color: "info" },
  Retired: { id: 4, name: "Retired", color: "error" },
};

export const statusChoices = Object.values(statusChoicesDict);

export const accessModeChoices = [
  { id: 1, name: "Public" },
  { id: 2, name: "Restricted" },
];
